import {
  loadRecommendationsPlaces,
  loadRecommendationsOverviews,
  loadRecommendationsEvents,
} from "@common/redux/slices/recommendation.slice";
import { reduxWrapper } from "@common/redux/store";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";
import { TicketsBundles } from "@kursk/components/pages/TicketsBundles/TicketsBundles";
import { loadPrices } from "@common/redux/slices/minAndMaxPrices.slice";

export default function TicketsBundlesPage() {
  return <TicketsBundles />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {

  await Promise.all([
    loadEntitiesFromQuery('ticketsbundles', query, store),
    store.dispatch(loadRecommendationsPlaces({ locales: query.locales })),
    store.dispatch(loadRecommendationsOverviews({})),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadPrices('ticketsbundles')),
  ]);

  return { props: {} };
})
